export default "__VITE_ASSET__B2OUbe8O__"